import analyticsService from '@/services/analyticsService'

const state = {
  loadingSuperuserStats: true,
  superUserStats: {}
}

const mutations = {
  'SET_SUPERUSER_STATISTICS' (state, stats) {
    state.superUserStats = stats
  },
  'SET_LOADING_SUPERUSER_STATISTICS' (state, status) {
    state.loadingSuperuserStats = status
  }
}

const actions = {
  getSuperUserStatistics (vuexContext) {
    vuexContext.commit('SET_LOADING_SUPERUSER_STATISTICS', true)
    analyticsService.getSuperUserStatistics(vuexContext.getters.token)
      .then(response => {
        if (response.statistics) {
          vuexContext.commit('SET_SUPERUSER_STATISTICS', response.statistics)
          vuexContext.commit('SET_LOADING_SUPERUSER_STATISTICS', false)
        }
      })
      .catch(() => {
        vuexContext.commit('SET_SUPERUSER_STATISTICS', {})
      })
  }
}

export default {
  state,
  mutations,
  actions
}
